import React from 'react';

import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';
import {
  Badge,
  BadgePropsT,
} from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/badges.scss';

export type NcBadgeT = React.FC<BadgePropsT>;

export const NcBadge: NcBadgeT = ({ className, ...props }) => {
  const classNames = mergeClassNameStrings(className, 'nc-badge');

  return (
    <Badge {...props} className={classNames} />
  );
};
